import { Routes } from '@angular/router';
import {AppRoutes} from './constants/app-routes';
import {authGuard} from './guards/authentication/auth.guard';

export const routes: Routes = [
  {
    path: AppRoutes.AUTH,
    loadChildren: () => import('./components/authentication/authentication-routes').then(m => m.authenticationRoutes)
  },

  {
    path: AppRoutes.APP,
    canActivate: [authGuard],
    loadChildren: () => import('./components/main/main-routes').then(m => m.mainRoutes)
  },

  { path: '**', redirectTo: AppRoutes.AUTH}
];
